module.exports = __webpack_public_path__ + "static/media/trex.1c2c9949.png";